import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { checkPixelCollision } from '../ndgmr.Collision-phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class DraggableSprite extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {string} name
   */
  constructor(scene, name) {
    super(scene);

    this._bg = ABCyaPhaser.Images.addImage(0,0,name, this);

    DraggableSprite.instances.push(this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => Phaser.Utils.Array.Remove(DraggableSprite.instances, this));

    this.lastPosX = 0;
    this.lastPosY = 0;
    this.enabled = true;

    /** @type {Phaser.GameObjects.Image[]} */
    this.hitTargets = [];
    this.game = '';
    this.doClickAction = (sender) => {};
    this.hitListener = (sender, target) => {};
    this.outListener = (sender) => {};

    this.name = name;

    if (name.includes('face')) {
      this.once(Phaser.GameObjects.Events.ADDED_TO_SCENE, () => {
        this.eyesRed = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._eyes_red, this.scene);
        this.eyesRed.alpha = 0;

        this.eyesGreen = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._eyes_green, this.scene);
        this.eyesGreen.alpha = 0;

        this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, this._updateEyes, this);

        this.once(Phaser.GameObjects.Events.DESTROY, () => {
          this.scene.events.off(Phaser.Scenes.Events.POST_UPDATE, this._updateEyes, this);
        });
      });
    }

    ABCyaPhaser.Container.setContainerInteractive(this);
    this.scene.input.setDraggable(this);
    this.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.handlePress,this);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick,this);
    this.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.doClickUp,this);
  }

  _updateEyes() {
    this.eyesRed.setPosition(this.x, this.y);
    this.eyesGreen.setPosition(this.x, this.y);
    this.eyesRed.setScale(this.scale);
    this.eyesGreen.setScale(this.scale);

    // place the eyes above the head
    if (this.parentContainer) {
      this.parentContainer.moveAbove(this.eyesRed, this);
      this.parentContainer.moveAbove(this.eyesGreen, this);
    }
    else {
      this.scene.children.moveAbove(this.eyesRed, this);
      this.scene.children.moveAbove(this.eyesGreen, this);
    }
  }

  handlePress (pointer, x, y) {
    if (!this.enabled) return;

    this.x = x;
    this.y = y;
  }

  doClick () {
    if (!this.enabled) return;
    let root = null;

    if (this.name.includes('_')) {
      const array = this.name.split('_');
      root = array[1];
    }
    else {
      root = this.name;
    }

    if (root !== null && root !== '') {
      if ((this.name.includes('hand') || this.name.includes('foot')) && this.game === 'assemble') {
        ABCyaPhaser.Audio.playOneShot(`${root}_bones`, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      }
      else {
        ABCyaPhaser.Audio.playOneShot(root, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      }
    }

    if (this.parentContainer) {
      this.parentContainer.bringToTop(this);

      if (this.eyesGreen) {
        this.parentContainer.bringToTop(this.eyesRed);
        this.parentContainer.bringToTop(this.eyesGreen);
      }
    }
    else {
      this.scene.children.bringToTop(this);

      if (this.eyesGreen) {
        this.scene.children.bringToTop(this.eyesRed);
        this.scene.children.bringToTop(this.eyesGreen);
      }
    }

    this.doClickAction(this);
  }

  doClickUp () {
    if (!this.enabled) return;

    for (let i = 0; i < this.hitTargets.length; i++) {

      const target = this.hitTargets[i];
      const collision = checkPixelCollision(this._bg, target, 0);

      if (collision) {
        this.hitListener(this, target);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_pop2, this.scene);

        // just one target can be hit, so return
        return;
      }
    }
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_slide_flip, this.scene);
    this.outListener(this);
  }

  moveToLastPosition () {
    ABCyaPhaser.Tweens.addTween(this, 500, { x: this.lastPosX, y: this.lastPosY }, Phaser.Math.Easing.Quadratic.Out);
  }

  flashCorrect () {
    if (this.name.includes('face')) {
      this.scene.tweens.killTweensOf(this.eyesRed);
      this.scene.tweens.killTweensOf(this.eyesGreen);

      this.eyesRed.alpha = 0;
      this.eyesGreen.alpha = 0;

      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 250, { alpha: 1 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 30, { alpha: 0, delay: 250 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 250, { alpha: 1, delay: 280 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 30, { alpha: 0, delay: 530 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 250, { alpha: 1, delay: 560 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 30, { alpha: 0, delay: 810 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 250, { alpha: 1, delay: 840 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 30, { alpha: 0, delay: 1090 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 250, { alpha: 1, delay: 1120 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesGreen, 30, { alpha: 0, delay: 1370 }, Phaser.Math.Easing.Bounce.In);
    }
  }

  flashIncorrect () {
    if (this.name.includes('face')) {
      this.scene.tweens.killTweensOf(this.eyesRed);
      this.scene.tweens.killTweensOf(this.eyesGreen);

      this.eyesRed.alpha = 0;
      this.eyesGreen.alpha = 0;

      ABCyaPhaser.Tweens.addTween(this.eyesRed, 250, { alpha: 1 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 30, { alpha: 0, delay: 250 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 250, { alpha: 1, delay: 280 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 30, { alpha: 0, delay: 530 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 250, { alpha: 1, delay: 560 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 30, { alpha: 0, delay: 810 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 250, { alpha: 1, delay: 840 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 30, { alpha: 0, delay: 1090 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 250, { alpha: 1, delay: 1120 }, Phaser.Math.Easing.Bounce.In);
      ABCyaPhaser.Tweens.addTween(this.eyesRed, 30, { alpha: 0, delay: 1370 }, Phaser.Math.Easing.Bounce.In);
    }
  }

  moveToLastPositionAndRotate () {
    this.scene.tweens.killTweensOf(this);
    this.angle = 0;

    ABCyaPhaser.Tweens.addTween(this, 500, { x: this.lastPosX, y: this.lastPosY, angle: 360 * 2 }, Phaser.Math.Easing.Quadratic.Out);
  }

  /** @type {DraggableSprite[]} */
  static instances = [];

  static showCorrect() {
    const len = DraggableSprite.instances.length;
    for (let i = 0; i < len; i++) {
      const thisOne = DraggableSprite.instances[i];
      if (thisOne.name.includes('face')) {
        thisOne.flashCorrect();
      }
    }
  }

  static showIncorrect () {
    const len = DraggableSprite.instances.length;
    for (let i = 0; i < len; i++) {
      const thisOne = DraggableSprite.instances[i];
      if (thisOne.name.includes('face')) {
        thisOne.flashIncorrect();
      }
    }
  }
}